/* @flow */

import React from 'react';

import KycCheckComponent from 'app/users/kycCheck';
import WebsitePageComponent from 'components/websiteStructure/pages';

export default function ISORegisterLeadsPage() {
  return (
    <WebsitePageComponent id="page.kyccheck.h1" noPaper>
      <KycCheckComponent />
    </WebsitePageComponent>
  );
}
